<template>
  <div class="async-btn">
    <i class="fas fa-sync rotate" v-if="!status" @click="emitData()"></i>
  </div>
</template>

<script>
export default {
  name: 'awaitReloadComponent',
  props: {
    status: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    emitData() {
      this.$emit('await');
      this.$alertBox.success(this.$t('op.listUpdated'));
    }
  }
};
</script>
